module.exports = __webpack_public_path__ + "img/auth-posnania-valentines.ac98bb8b.png";